export const SHOPIFY_STOREFRONT_GRAPHQL_API = "https://hyper-karting.myshopify.com/api/2025-01/graphql.json";
export const SHOPIFY_STOREFRONT_TOKEN = "74c3480f0faab00d5878020b7767ede5";
